import { Injectable } from '@angular/core';
import {AngularFirestore} from '@angular/fire/firestore';
import {AngularFireAuth} from "@angular/fire/auth";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  constructor(
    public afs: AngularFirestore,
    private firebaseAuth: AngularFireAuth,
  ) { }

  getUidByUserId(userId) {
    return this.afs.collection('users', ref => ref.where('id', '==', `${userId}`)).valueChanges();
  }
  getPublicGroups() {
    return this.afs.collection(`groups`).valueChanges();
  }
  deleteGroup(id) {
    return this.afs.collection(`groups`).doc(`${id}`).delete();
  }
  getUserById(id) {
    return this.afs.collection('users', (ref) => ref.where('id', '==', `${id}`)).valueChanges()
  }
  getUserByEmail(email) {
    return this.afs.collection('users', (ref) => ref.where('email', '==', `${email}`)).valueChanges()
  }
  addUserToGroup(group) {
    return this.afs.collection(`groups`).doc(`${group.id}`).update(group);
  }
  updateGroup(id, group) {
    return this.afs.collection(`groups`).doc(`${group.id}`).update(group);
  }
  createGroup(name, user) {
    const collection = this.afs.collection('groups').doc(name);
    return collection.set({
      name,
      id: name,
      users: [user.id],
      procedures: [],
      owner: { uid: user.uid, id: user.id },
    });
  }
  updateUser(userUid, credentials) {
    this.afs.doc(`users/${userUid}/`).update(credentials);
  }
  handlePremiumRole(userUid, credentials) {
    return this.afs.doc(`users/${userUid}/`).set(credentials);
  }
  getPremiumUsers() {
    return this.afs.collection('users', (ref) => ref.where('role', '==', 'premium')).valueChanges()
  }
  getCurrentUser() {
    return new Observable((observer) => {
      this.firebaseAuth.authState.subscribe( authState => {
        if (authState) {
          this.getUserByEmail(authState.email).subscribe((user:any) => {
            observer.next(user[0]);
          });
        }
      });
    })
  }
  getDeviceByName(deviceName): Observable<any> {
    return this.afs.doc(`devicesList/${deviceName}`).valueChanges();
  }
  removeDeviceFromList(deviceName) {
    return this.afs.doc(`devicesList/${deviceName}`).delete();
  }
  updateDeviceUsers(deviceName, updatedUsers) {
    return this.afs.collection('devicesList').doc(deviceName).update({users: updatedUsers});
  }
  sendEmail(uid: string, email: string, html: string | number, subject: string): Promise<void> {
    return this.afs.collection('mail').doc(uid + Date.now()).set({
      to: email,
      message: {
        html,
        subject
      }
    });
  }
  setDeveloperToList(user, usersList) {
    const data = {
      developerId: user.id ? user.id : user.developerId,
      developerEmail: user.email? user.email : user.developerEmail,
      allowedUsers: usersList,
      photoURL: user.photoURL
    }
    return this.afs.doc(`developersList/${user.id ? user.id : user.developerId}`).set(data);
  }

  getDevelopersList() {
    return this.afs.collection('developersList').valueChanges();
  }
  deleteDeveloperFromList(id) {
    return this.afs.doc(`developersList/${id}`).delete();
  }
  getRecordings(userId, sensorType) {
    return this.afs.collection(`records/${userId}/${sensorType}/`, ref => ref.orderBy('dateCreated').limitToLast(20)).valueChanges();
  }
  getRecordingsLoadMore(userId, sensorType, start) {
    return this.afs.collection(`records/${userId}/${sensorType}/`, ref => ref.orderBy('dateCreated').endBefore(start).limitToLast(20)).valueChanges();
  }
}
